export default "/_next/static/chunks/fonts/WaitingfortheSunrise-Regular-9707069a35e15593ee6046bbbb70da64.woff";